import $ from 'jquery';
import { deleteTemplate } from '~loader/loader-api/deleteTemplate';
import { handleTabTemplates } from '~src/sidebar/index';

export const deleteTemplateClickHandler = async (event) => {
  event.preventDefault();
  event.stopPropagation();

  const templateId = $(event.currentTarget).attr('data-giotto-delete-template');
  const isGlobal =
    $(event.currentTarget).attr('data-giotto-isglobal') === 'true';

  const deleted = await deleteTemplate(templateId, isGlobal);
  if (deleted) {
    await handleTabTemplates(true);
  }
};
